import { useState } from 'react';
import PhoneNumberDialog from './PhoneNumberDialog';
import SmsCodeDialog from './SmsCodeDialog';

type LoginDialogPropsType = {
  onClose: () => void;
};
const LoginDialog = ({ onClose }: LoginDialogPropsType): JSX.Element => {
  const [phone, setPhone] = useState<string>('');
  const [currentStep, setCurrentStep] = useState<number>(1);

  const handlePhoneNumberSubmit = (phoneNumber: string): void => {
    setPhone(phoneNumber);
    setCurrentStep(2);
  };

  return currentStep === 1 ? (
    <PhoneNumberDialog
      onClose={onClose}
      onPhoneNumberSubmit={handlePhoneNumberSubmit}
    />
  ) : (
    <SmsCodeDialog
      onBackClick={() => setCurrentStep(1)}
      onClose={onClose}
      phone={phone}
    />
  );
};

export default LoginDialog;
